var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-button',{attrs:{"text":"","loading":_vm.loading,"label":_vm.getButtonLabel,"color":"branco"},on:{"click":_vm.goToSelectClients}})}
var staticRenderFns = []

export { render, staticRenderFns }